<button mat-icon-button class="dialog-close-btn" (click)="onClose()">
  <mat-icon>close</mat-icon>
</button>

<h2 mat-dialog-title class="modal-title">License Expiry</h2>

<!-- <div *ngIf="isLoadingClient" class="loading-container">
  <p>Loading client data...</p>
</div> -->

<!-- <div *ngIf="!isLoadingClient && clientData" class="client-info">
  <h3>Client Information</h3>
  <div class="info-row">
    <span class="label">Client Name:</span>
    <span class="value">{{ clientData.clientName }}</span>
  </div>
  <div class="info-row">
    <span class="label">CMS Fin Number:</span>
    <span class="value">{{ clientData.cmsFinNumber }}</span>
  </div>

</div> -->

<form [formGroup]="expiryForm" (ngSubmit)="onSubmit()" >

  <mat-dialog-content class="form-content">

    <!-- Row 1: License Expiry Date and Reason -->
    <div class="form-row">
      <div class="form-item">
        <app-data-picker
          [label]="'License Expiry Date'"
          [form]="expiryForm"
          controlName="expiryDate"
          [minDate]="today">
        </app-data-picker>
      </div>

      <div class="form-item">
        <app-input-dropdown
          [label]="'Reason'"
          [formGroup]="expiryForm"
          controlName="reason"
          [options]="reasonOptions"
          (selectionChange)="onReasonSelect($event)">
        </app-input-dropdown>
      </div>
    </div>

    <!-- Row 2: Comment (full width) -->
    <div class="form-item full-width">
      <mat-form-field appearance="outline" class="form-field full-width">
        <mat-label>Comment</mat-label>
        <textarea
          matInput
          formControlName="comment"
          placeholder="Add additional details..."
          rows="4"></textarea>
      </mat-form-field>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    <app-form-actions-buttons [buttons]="submitButtons"></app-form-actions-buttons>
  </mat-dialog-actions>
</form>
